import { Button, Stack, csx } from '@vtex/admin-ui'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import type { DefaultProps } from 'typings'
import { usePromotionsListState } from '../usePromotionsListState'

export function FilterBar(props: DefaultProps) {
  const { filtersState } = usePromotionsListState()

  const hasFilterApplied = useMemo(
    () => filtersState.some((filter) => filter.values.length),
    [filtersState]
  )

  function clearAll() {
    filtersState.forEach((filter) => filter.clear())
  }

  return (
    <Stack
      direction="row"
      space="$space-2"
      className={csx({ order: -1, marginTop: '20px !important' })}
    >
      {props.children}

      <Button
        variant="neutralTertiary"
        onClick={clearAll}
        hidden={!hasFilterApplied}
      >
        <FormattedMessage id="admin/promotions.filters.actions.clear-all" />
      </Button>
    </Stack>
  )
}
